import { logToDataLayer } from '../hooks/useAnalytics';
import {
  getSmartFilterEvent,
  beachAnalyticsParams,
  centerAnalyticsParams,
  metroAnalyticsParams,
  priceAnalyticsParams,
  guestRatingAnalyticsParams,
} from './analytics';
import transformKey from './transformKey';

const rangeFilterAnalyticsParams = {
  distanceBeachTo: beachAnalyticsParams,
  distanceCenterTo: centerAnalyticsParams,
  distanceMetroTo: metroAnalyticsParams,
  priceTo: priceAnalyticsParams,
  guestRatingTo: guestRatingAnalyticsParams,
  guestRatingFrom: guestRatingAnalyticsParams,
};

const buildFilterEvent = (params) => ({
  event: 'Filter',
  travelAction: 'Filter',
  travelFilterSet: 'smart_filter',
  ...params,
});

const getAnalyticsParamsForCheckGroupFilter = (description) =>
  buildFilterEvent({ travelFilterValue: description });

const getAnalyticsParamsForRangeFilter = (filterKey) =>
  buildFilterEvent(rangeFilterAnalyticsParams[filterKey]);

const getAnalyticsParamsForGeographicalFilter = (destination) =>
  buildFilterEvent({ travelFilterValue: destination });

export const logSmartFilterEvents = ({ body, translationDictionary, geographicalDictionary, filterEvent }) => {
  const { filters, rangeFilters } = body ?? {};
  const geographicalFilterValues = [];
  const checkGroupFilterValues = [];

  (Array.isArray(filters) ? filters : []).forEach((key) => {
    const geographicalFilterMatch = geographicalDictionary?.[key]?.description;
    if (geographicalFilterMatch) {
      geographicalFilterValues.push(geographicalFilterMatch);
      return;
    }
    const translationMatch = Object.values(translationDictionary ?? {}).find((item) => item.key === key);
    if (translationMatch) {
      checkGroupFilterValues.push(transformKey(translationMatch.description));
    }
  });

  const rangeFilterValues = (Array.isArray(rangeFilters) ? rangeFilters : []).map((rangeFilter) => rangeFilter?.key).filter(Boolean);

  const listOfFilters = [...geographicalFilterValues, ...checkGroupFilterValues, ...rangeFilterValues].join(',');
  logToDataLayer({ ...getSmartFilterEvent(), eventInfo: listOfFilters });

  checkGroupFilterValues.forEach((value) => {
    logToDataLayer({ ...filterEvent, ...getAnalyticsParamsForCheckGroupFilter(value) });
  });
  geographicalFilterValues.forEach((value) => {
    logToDataLayer({ ...filterEvent, ...getAnalyticsParamsForGeographicalFilter(value) });
  });
  rangeFilterValues.forEach((value) => {
    logToDataLayer({ ...filterEvent, ...getAnalyticsParamsForRangeFilter(value) });
  });
};
